// Modules:
import React from 'react';

// Mui:
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

const styles = {
    '&.MuiDialogTitle-root': {
        padding: '1rem',
    },
};

const ChartInfoModal = ({ chartInfoModalOpen, setChartInfoModalOpen }) => (
    <div>
        <Dialog
            onClose={() => setChartInfoModalOpen(false)}
            aria-labelledby="about-data-dialogue"
            open={chartInfoModalOpen}
            maxWidth="xl"
        >
            <MuiDialogTitle
                sx={styles}
                id="about-data-title"
                onClose={() => setChartInfoModalOpen(false)}
            >
                Interacting with the chart legend
            </MuiDialogTitle>
            <MuiDialogContent dividers>
                <Typography component="div" gutterBottom>
                    <Typography component="p">
                        Clicking on a dataset within the chart legend will
                        toggle that dataset on and off.
                    </Typography>
                    <div className="chart-info-modal-video-contianer">
                        <video
                            autoPlay
                            loop
                            playsInline
                            className="chart-info-modal-video"
                        >
                            <source src="/ephtportal/images/Chart_Info_Modal_Video.mp4" />
                            <track kind="captions" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </Typography>
            </MuiDialogContent>
            <MuiDialogActions>
                <Button
                    autoFocus
                    onClick={() => setChartInfoModalOpen(false)}
                    color="primary"
                >
                    Close
                </Button>
            </MuiDialogActions>
        </Dialog>
    </div>
);

export default ChartInfoModal;
